import {
  dialog
} from '../base';

const modal = document.querySelector('#dialog-update');

export function showUpdateModal() {
  if (modal === null) {
    return;
  }
  setTimeout(() => {
    dialog.open('update');
  }, 1000);
}
